import { Component, HostListener, OnInit } from '@angular/core';
import { ComponentCanDeactivate } from 'app/helpers/pendingChangesGuard';
import { TranslationService } from 'app/services/api/translation/translation.service';

@Component({
    selector: 'pension-coefficients',
    templateUrl: './pension-coefficients.component.html',
})
export class PensionCoefficientsComponent implements OnInit, ComponentCanDeactivate {
    public beforeLeaveMessage = this.translationService.translate('info_leave_form_message');
    private childPendingChangesMap = new Map<string, boolean>();

    constructor(private translationService: TranslationService) {}

    @HostListener('window:beforeunload')
    canDeactivate(): boolean {
        try {
            for (let [key, value] of this.childPendingChangesMap) {
                if (value) {
                    return false;
                }
            }
            return true;
        } catch (e) {
            return true;
        }
    }

    ngOnInit(): void {}

    setChildHasPendingChanges(event: any, key: string) {
        this.childPendingChangesMap.set(key, event);
    }
}
